'use client';

import SectionWrapper from '../SectionWrapper';
import ButtonContainer from '../ButtonContainer';
import Button from '../Button';
import Icon from '../Icon';
import MediaContainer from '../MediaContainer';
import CloudImage from '../CloudImage';
import {
  LuCalculator,
  LuPhone,
  LuStar,
  LuSearch /* …etc… */,
} from 'react-icons/lu';

const ICONS = {
  LuCalculator,
  LuPhone,
  LuStar,
  LuSearch,
  // add any other icons you need here
};

export default function CtaSection({
  content,
  children,
  className = '',
  imgPadding = '',
  reverse = false,
  imgContain = false, // ← new prop
}) {
  const {
    id,
    overline,
    title,
    coupon,
    body,
    button = {},
    image = {},
  } = content;

  const IconComponent = ICONS[button.iconName] || null;
  const rowClass = reverse ? 'laptop:flex-row-reverse' : 'laptop:flex-row';
  const imgFitClass = imgContain ? '!object-contain' : 'object-cover';

  return (
    <SectionWrapper
      id={id}
      className={`bg-secondary relative overflow-hidden rounded ${className}`}
    >
      {/* SVG background… */}

      <div className="relative z-10 flex flex-col items-center justify-center space-y-6">
        <div className={`${rowClass} flex flex-col items-center gap-6`}>
          <div className="laptop:pb-6 flex-1 space-y-6 px-6 py-8">
            {overline && <p className="font-semibold uppercase">{overline}</p>}
            <h2 className="capitalize">{title}</h2>
            {coupon && (
              <h3 className="text-secondary bg-secondary-foreground rounded p-2 uppercase">
                {coupon}
              </h3>
            )}
            <p className="text-sm">{body}</p>
            <ButtonContainer className="mx-auto">
              {children
                ? children
                : button.href && (
                    <Button href={button.href}>
                      {IconComponent && (
                        <Icon icon={IconComponent} className="mr-2" />
                      )}
                      {button.text}
                    </Button>
                  )}
            </ButtonContainer>
          </div>

          {image.publicId && (
            <MediaContainer className="laptop:aspect-square aspect-video flex-1">
              <CloudImage
                publicId={image.publicId}
                alt={image.alt}
                className={`${imgFitClass} ${imgPadding}`}
              />
            </MediaContainer>
          )}
        </div>
      </div>
    </SectionWrapper>
  );
}
